import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import NavigationHeader from './NavigationHeader';
import HeroSection from './HeroSection';
import AboutSection from './AboutSection';
import ServicesSection from './ServicesSection';
import TestimonialsSection from './TestimonialsSection';
import FAQSection from './FAQSection';
import BlogSection from './BlogSection';
import MapSection from '../shared/MapSection';
import GMBFeedSection from '../shared/GMBFeedSection';
import TagsSection from '../shared/TagsSection';
import Footer from './Footer';
import { LocalBusinessSchema } from '../SchemaScript';
import extractSchemaData from '../../utils/extractSchemaData';

const TemplateContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  minHeight: '100vh',
  backgroundColor: '#ffffff'
}));

const Template4 = ({ 
  templateData,
  isEditable = false,
  onTemplateUpdate
}) => {
  const {
    businessInfo,
    navigation,
    aboutUs,
    services,
    testimonials,
    faq,
    blogs,
    footer,
    location,
    gmbFeed
  } = templateData || {};

  const schemaData = extractSchemaData(templateData);

  return (
    <TemplateContainer>
      {schemaData && <LocalBusinessSchema business={schemaData} />}
      <NavigationHeader businessInfo={businessInfo} navigation={navigation} />
      <HeroSection businessInfo={businessInfo} />
      <AboutSection aboutUs={aboutUs} />
      <ServicesSection services={services} />
      <TestimonialsSection testimonials={testimonials} />
      <MapSection location={location} />
      <GMBFeedSection gmbFeed={gmbFeed} />
      <FAQSection faq={faq} />
      <BlogSection blogs={blogs} />
      <TagsSection 
        businessInfo={businessInfo}
        services={services}
      />
      <Footer footer={footer} />
    </TemplateContainer>
  );
};

export default Template4;